// extracted by mini-css-extract-plugin
export default {"informationBanner":"_9Dnp","bannerMessage":"qMiY","icon":"ctEY"};